export class ApiError extends Error {
    constructor(message: string, public statusCode?: number, public errorCode?: string, public originalError?: any) {
        super(message);
        this.name = 'ApiError';
        // Maintains proper prototype chain for instanceof checks
        Object.setPrototypeOf(this, ApiError.prototype);
    }
}

export class DuplicateEmailError extends ApiError {
    public readonly email: string;

    constructor(message: string, email: string) {
        super(message, 400, 'DUPLICATE_EMAIL');
        this.name = 'DuplicateEmailError';
        this.email = email;
        // Maintains proper prototype chain for instanceof checks
        Object.setPrototypeOf(this, DuplicateEmailError.prototype);
    }
}

export class AuthenticationError extends ApiError {
    constructor(message: string) {
        super(message, 401, 'AUTHENTICATION_ERROR');
        this.name = 'AuthenticationError';
        // Maintains proper prototype chain for instanceof checks
        Object.setPrototypeOf(this, AuthenticationError.prototype);
    }
}

export class NetworkError extends ApiError {
    constructor(message: string) {
        super(message, 0, 'NETWORK_ERROR');
        this.name = 'NetworkError';
        // Maintains proper prototype chain for instanceof checks
        Object.setPrototypeOf(this, NetworkError.prototype);
    }
}
